/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 PRO React using thie file.
 */

const colors = {
  background: {
    default: "#f0f2f5",
  },

  text: {
    main: "#7b809a",
    focus: "#7b809a",
  },

  secondaryRed: {
    main: "#f83a46",
    focus: "#f83a46",
  },

  primaryBlack: {
    main: "#19191b",
    focus: "#19191b",
    hover: "#e11921",
  },

  secondaryBlue: {
    main: "#8ba5ce",
    focus: "#8ba5ce",
  },

  primaryRed: {
    main: "#ff2c56",
    focus: "#ff2c56",
  },

  secondaryGreen: {
    main: "#02c295",
    focus: "#02c295",
  },

  trendGreen: {
    main: "#02c295",
    focus: "#02c295",
  },

  trendRed: {
    main: "#e23a3a",
    focus: "#e23a3a",
  },

  iconBlue: {
    main: "#448cff",
    focus: "#448cff",
  },

  transparent: {
    main: "#00000000",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#e91e63",
    focus: "#e91e63",
  },

  secondary: {
    main: "#7b809a",
    focus: "#8f93a9",
  },

  newColor: {
    main: "#323232",
    focus: "#323232",
  },

  textDark: {
    main: "#000000",
    focus: "#000000",
  },

  textLight: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  sidebarTextLight: {
    main: "#bdbdbf",
    focus: "#bdbdbf",
  },

  sidebarTextDark: {
    main: "#19191b",
    focus: "#19191b",
  },

  info: {
    main: "#323232",
    focus: "#1662C4",
  },

  success: {
    main: "#8ba5ce",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gray: {
    20: "#CECECE",
    40: "#989797",
    60: "#6F6E6E",
    80: "#272727",
  },

  gray20: {
    main: "#CECECE",
    focus: "#CECECE",
  },

  gray40: {
    main: "#989797",
    focus: "#989797",
  },

  gray60: {
    main: "#6F6E6E",
    focus: "#6F6E6E",
  },

  gray80: {
    main: "#272727",
    focus: "#272727",
  },

  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#323232",
      state: "#323232",
    },

    success: {
      main: "#8ba5ce",
      state: "#8ba5ce",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
    achieved: "#FF6127",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

const getKeysWithMain = (obj) => {
  const keys = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (typeof obj[key] === "object") {
      if ("main" in obj[key]) {
        keys.push(key);
      }
      keys.push(...getKeysWithMain(obj[key]));
    }
  }
  return [...new Set(keys)];
};

export const colorsList = getKeysWithMain(colors) || [];

export default colors;
